export default __webpack_public_path__ + "static/media/ic-automatic-round.adc27bf6.svg";